import { cart } from 'src/common/assets/i18n-assets/fr/cart';
import { common } from 'src/common/assets/i18n-assets/fr/common';
import { habaAddress } from 'src/common/assets/i18n-assets/fr/habaAddress';
import { habaCart } from 'src/common/assets/i18n-assets/fr/habaCart';
import { habaCatalogForm } from 'src/common/assets/i18n-assets/fr/habaCatalogForm';
import { habaContactForm } from 'src/common/assets/i18n-assets/fr/habaContactForm';
import { habaCheckout } from 'src/common/assets/i18n-assets/fr/habaCheckout';
import { habaCommon } from 'src/common/assets/i18n-assets/fr/habaCommon';
import { habaCountries } from 'src/common/assets/i18n-assets/fr/habaCountries';
import { habaMyAccountNavigation } from 'src/common/assets/i18n-assets/fr/habaMyAccountNavigation';
import { habaProduct } from 'src/common/assets/i18n-assets/fr/habaProduct';
import { habaUser } from 'src/common/assets/i18n-assets/fr/habaUser';
import { habaWishlist } from 'src/common/assets/i18n-assets/fr/habaWishlist';
import { userProfile } from 'src/common/assets/i18n-assets/fr/userProfile';
import { product } from 'src/common/assets/i18n-assets/fr/product';
import { newsletter } from 'src/common/assets/i18n-assets/fr/newsletter';
import { address } from 'src/common/assets/i18n-assets/fr/address';

export const frTranslationsHaba = {
  cart,
  common,
  address,
  habaAddress,
  habaCart,
  habaCatalogForm,
  habaContactForm,
  habaCheckout,
  habaCommon,
  habaCountries,
  habaMyAccountNavigation,
  habaProduct,
  habaUser,
  habaWishlist,
  userProfile,
  product,
  newsletter,
};
